import React from 'react';
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import {SimpleHeader} from "../../../widgets/header/SimpleHeader";
import {Container} from "@mui/material";
import Grid from "@mui/material/Grid";

const StatistichePersonali = () => {
	const classes = BaseStyle();
	
	return (
		<React.Fragment>
			<main className={classes.main}>
				<SimpleHeader title={"Statistiche"} back={true} backPosition={"/gestione"}/>
				<Container maxWidth={"xl"} component={"article"}>
					<Grid container spacing={3}>
						<Grid item xs={12} md={8}>
							...lavori in corso ...
						</Grid>
					
					</Grid>
				</Container>
			</main>
		</React.Fragment>
	);
};

export default React.memo(StatistichePersonali)
